module.exports = __webpack_public_path__ + "static/etctrispace-regularnarrow-webfont-229edbb23193f9d324255d2b085366bc.woff";